var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"disabled":_vm.text === undefined || _vm.text === '' || _vm.text === null,"effect":"dark","placement":"top","content":"复制","open-delay":200}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.text),expression:"text"}],staticClass:"el-icon-document-copy tb-hover-show",on:{"click":_vm.copy}})])
}
var staticRenderFns = []

export { render, staticRenderFns }